var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductiterationPana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 481.76,
    height: 467,
    viewBox: "0 0 481.76 467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product_iteration-pana",
    "data-name": "Product iteration-pana",
    transform: "translate(-15.42 -22.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphic--inject-6",
    transform: "translate(15.42 22.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9654",
    "data-name": "Path 9654",
    d: "M193.834,143.063A73.985,73.985,0,0,1,210.1,131.835l.174-18.374,29.663-6.431,7.758,16.638a74.228,74.228,0,0,1,19.476,3.522l13.1-12.851,25.519,16.434-6.278,17.241a73.985,73.985,0,0,1,11.228,16.271l18.374.173,6.431,29.663-16.628,7.758a74.234,74.234,0,0,1-3.552,19.446l12.841,13.1-16.424,25.519-17.241-6.278a74.574,74.574,0,0,1-16.271,11.228l-.174,18.374-29.674,6.451-7.748-16.628a74.58,74.58,0,0,1-19.476-3.522l-13.076,12.851-25.519-16.434,6.278-17.231a74.514,74.514,0,0,1-11.228-16.271l-18.374-.174-6.431-29.674,16.638-7.758a74.158,74.158,0,0,1,3.471-19.486l-12.811-13.076L176.583,136.8ZM210.4,176.605a26.99,26.99,0,1,0-.051,0Z",
    transform: "translate(-12.566 -20.296)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9655",
    "data-name": "Path 9655",
    d: "M193.834,143.063A73.985,73.985,0,0,1,210.1,131.835l.174-18.374,29.663-6.431,7.758,16.638a74.228,74.228,0,0,1,19.476,3.522l13.1-12.851,25.519,16.434-6.278,17.241a73.985,73.985,0,0,1,11.228,16.271l18.374.173,6.431,29.663-16.628,7.758a74.234,74.234,0,0,1-3.552,19.446l12.841,13.1-16.424,25.519-17.241-6.278a74.574,74.574,0,0,1-16.271,11.228l-.174,18.374-29.674,6.451-7.748-16.628a74.58,74.58,0,0,1-19.476-3.522l-13.076,12.851-25.519-16.434,6.278-17.231a74.514,74.514,0,0,1-11.228-16.271l-18.374-.174-6.431-29.674,16.638-7.758a74.158,74.158,0,0,1,3.471-19.486l-12.811-13.076L176.583,136.8ZM210.4,176.605a26.99,26.99,0,1,0-.051,0Z",
    transform: "translate(-12.566 -20.296)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9656",
    "data-name": "Path 9656",
    d: "M209.312,175.569l.357-.541c.265-.367.623-.9,1.1-1.572l.806-1.153c.327-.419.715-.827,1.113-1.3l1.307-1.5a21.888,21.888,0,0,1,1.623-1.582,38.012,38.012,0,0,1,9.524-6.676,40.166,40.166,0,0,1,14.811-4.144l2.174-.153h2.225a17.066,17.066,0,0,1,2.276.1l2.307.276,1.174.153,1.164.255,2.358.531c.8.2,1.562.5,2.358.745a20.412,20.412,0,0,1,2.358.857,36.422,36.422,0,0,1,4.624,2.256c.745.439,1.531.847,2.266,1.337l2.184,1.552c.357.276.745.51,1.092.806l1.021.9c.674.612,1.388,1.194,2.042,1.848a41.983,41.983,0,0,1,3.685,4.236,43.647,43.647,0,0,1,3.2,4.808c.459.847.857,1.745,1.307,2.623.2.449.449.878.623,1.347l.521,1.388a44.919,44.919,0,0,1,1.756,5.767,46.113,46.113,0,0,1,.8,6.125l.112,1.552v3.124a11.519,11.519,0,0,1-.112,1.572c-.133,1.021-.265,2.042-.388,3.144l-.7,3.113A40.065,40.065,0,0,1,268.547,228.8L266,230.731l-2.766,1.694-.674.408-.715.347-1.409.684-1.409.684-1.449.541a45.729,45.729,0,0,1-5.88,1.786,46.264,46.264,0,0,1-5.971.8l-1.49.1h-1.48a27.619,27.619,0,0,1-2.93-.1,43.145,43.145,0,0,1-5.686-.909,43.9,43.9,0,0,1-5.39-1.6c-.868-.337-1.694-.745-2.531-1.113l-1.245-.551c-.408-.194-.786-.449-1.184-.663l-2.307-1.317c-.755-.47-1.439-1.021-2.154-1.521a36.747,36.747,0,0,1-3.971-3.266,20.809,20.809,0,0,1-1.756-1.8c-.551-.623-1.143-1.194-1.654-1.837l-1.46-1.929-.715-.949-.623-1.021c-.408-.663-.806-1.327-1.215-1.98s-.684-1.368-1.021-2.042-.663-1.337-.96-2.042-.5-1.368-.755-2.042a40.166,40.166,0,0,1-2.358-15.2,38.28,38.28,0,0,1,2.133-11.433c.276-.745.449-1.49.766-2.133l.827-1.807c.265-.561.48-1.082.725-1.541s.5-.857.714-1.225l1.021-1.643c.225-.367.347-.551.347-.551s-.092.2-.3.582-.531.949-.929,1.674l-.694,1.225c-.235.459-.439,1.021-.694,1.552l-.8,1.807a22.5,22.5,0,0,0-.745,2.133,38.544,38.544,0,0,0-2.042,11.371,39.892,39.892,0,0,0,2.419,15.056l.755,2.042c.3.663.633,1.317.959,2.042a18.143,18.143,0,0,0,1.021,2.042c.408.674.8,1.307,1.2,1.96l.612,1.021.715.939c.48.633,1.021,1.266,1.449,1.909a17.9,17.9,0,0,0,1.643,1.807,20.213,20.213,0,0,0,1.735,1.766,36.832,36.832,0,0,0,3.94,3.226c.7.5,1.388,1.021,2.133,1.5l2.3,1.317c.388.214.766.459,1.174.653l1.245.378c.827.357,1.643.766,2.491,1.092a43.9,43.9,0,0,0,5.328,1.572,40.614,40.614,0,0,0,5.624.888c.959.082,1.929.061,2.9.1h1.46l1.47-.1a45.014,45.014,0,0,0,5.89-.786,44.07,44.07,0,0,0,5.8-1.776l1.439-.541,1.388-.663,1.4-.684.694-.337.663-.4,2.664-1.643,2.511-1.9a39.483,39.483,0,0,0,13.648-21.191c.235-1.021.459-2.041.694-3.062a28.5,28.5,0,0,0,.378-3.062,9.789,9.789,0,0,0,.112-1.541v-3.093l-.112-1.531a45.274,45.274,0,0,0-.786-6.012,44.119,44.119,0,0,0-1.725-5.686l-.51-1.378c-.163-.459-.408-.888-.613-1.327-.439-.868-.827-1.756-1.286-2.593a41.555,41.555,0,0,0-3.144-4.747,42.479,42.479,0,0,0-3.634-4.206c-.653-.643-1.358-1.215-2.042-1.817l-1.021-.9c-.347-.286-.725-.531-1.082-.8-.715-.521-1.439-1.021-2.144-1.552a23.86,23.86,0,0,0-2.246-1.317,35.077,35.077,0,0,0-4.573-2.246,19.956,19.956,0,0,0-2.327-.857c-.786-.245-1.541-.541-2.327-.745l-2.327-.521-1.153-.265-1.164-.153-2.287-.286c-.745-.112-1.511-.071-2.246-.112a17.663,17.663,0,0,0-2.2,0l-2.154.143a40.044,40.044,0,0,0-14.709,4.032,38.156,38.156,0,0,0-9.514,6.564,21.966,21.966,0,0,0-1.633,1.552l-1.317,1.48c-.408.459-.806.868-1.123,1.276l-.837,1.133-1.133,1.541q-.163.238-.347.459Z",
    transform: "translate(-11.529 -19.259)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9657",
    "data-name": "Path 9657",
    d: "M193.839,143.067l-1.1-.388-3.287-1.174-12.964-4.634h.1L160.194,162.39v-.163L173.056,175.3l.061.061v.092a74.669,74.669,0,0,0-3.491,19.395v.112h-.092l-16.628,7.768.1-.214c2.042,9.34,4.185,19.262,6.451,29.674l-.2-.173,18.374.163h.133l.061.122a74.363,74.363,0,0,0,11.228,16.22l.092.1v.133l-6.268,17.231-.092-.276L208.3,282.136H208l13.086-12.851.112-.112h.143a74.52,74.52,0,0,0,19.395,3.511h.153l.061.143c2.429,5.216,5.1,10.892,7.758,16.638l-.286-.153,29.663-6.431-.2.255c0-5.788.112-12.045.173-18.374v-.153l.143-.071a74.637,74.637,0,0,0,16.2-11.228h0l.122-.1h.153l17.231,6.278-.306.1,16.434-25.519v.327l-12.841-13.1-.112-.112v-.153a73.791,73.791,0,0,0,3.522-19.395v-.153l.143-.071,16.638-7.748-.143.286q-3.287-15.2-6.421-29.674l.235.194-18.374-.184h-.153l-.061-.133a74.006,74.006,0,0,0-11.228-16.22l-.092-.1V147.7l6.278-17.23.092.255-25.519-16.445h.255L267.14,127.123l-.082.082h-.112a74.075,74.075,0,0,0-19.395-3.532h-.1v-.092l-7.676-16.5.174.082-29.684,6.39.092-.112c-.082,7.35-.143,13.362-.2,18.374v.051h0a75.541,75.541,0,0,0-12.555,8.044c-1.286,1.021-2.215,1.827-2.838,2.358s-.919.8-.919.8,1.143-1.143,3.705-3.215a73.308,73.308,0,0,1,12.525-8.166v.082c0-4.992.092-11,.143-18.374V113.3h.092l29.663-6.472h.122v.112c2.409,5.1,4.951,10.575,7.778,16.618l-.153-.092a74.515,74.515,0,0,1,19.527,3.511h-.194l13.035-12.831.112-.112.143.082,25.519,16.424.153.092-.061.174c-2.042,5.594-4.083,11.32-6.268,17.231l-.051-.235a74.77,74.77,0,0,1,11.32,16.332l-.214-.133,18.374.174h.194v.194q3.144,14.464,6.441,29.663v.2l-.184.082-16.628,7.758.143-.225a74.421,74.421,0,0,1-3.532,19.548l-.061-.265,12.851,13.1.143.143-.112.184-16.434,25.519-.112.174-.194-.072L294.384,253.9l.276-.051h0a74.73,74.73,0,0,1-16.332,11.3l.143-.235c-.061,6.3-.122,12.555-.174,18.374v.2l-.214.051-29.663,6.421-.2.051-.092-.194-7.748-16.628.214.143a74.608,74.608,0,0,1-19.537-3.542l.255-.061-13.025,12.841-.143.133-.163-.1-25.519-16.444-.163-.1.061-.184c2.195-5.992,4.338-11.892,6.288-17.231v.235a74.772,74.772,0,0,1-11.29-16.332l.194.112-18.374-.184h-.163v-.163c-2.246-10.412-4.389-20.334-6.41-29.674V202.5l.133-.071,16.638-7.737-.092.153a74.708,74.708,0,0,1,3.532-19.446v.153L159.98,162.441l-.082-.071.061-.092,16.475-25.519V136.7h.061l12.811,4.716,3.287,1.215Z",
    transform: "translate(-12.571 -20.3)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9658",
    "data-name": "Path 9658",
    d: "M327.622,293.66l-59.1,37.768H462.271V293.66Z",
    transform: "translate(-10.164 -16.42)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9659",
    "data-name": "Path 9659",
    d: "M433.48,270.81v84.407L488.5,313.008Z",
    transform: "translate(-6.739 -16.895)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9660",
    "data-name": "Path 9660",
    d: "M363,310.5h1.592v5.614H368.1v1.3H363Z",
    transform: "translate(-8.203 -16.071)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9661",
    "data-name": "Path 9661",
    d: "M373.451,315.92h-3.205l-.612,1.47H368l3.062-6.89h1.582l3.062,6.89h-1.674Zm-.51-1.215-1.092-2.674-1.092,2.634Z",
    transform: "translate(-8.099 -16.071)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9662",
    "data-name": "Path 9662",
    d: "M376.07,314.358V310.5h1.592v3.8c0,1.317.572,1.858,1.541,1.858s1.531-.541,1.531-1.858v-3.8h1.582v3.858a3.124,3.124,0,1,1-6.247,0Z",
    transform: "translate(-7.931 -16.071)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9663",
    "data-name": "Path 9663",
    d: "M390.049,310.5v6.89h-1.307l-3.44-4.185v4.185H383.73V310.5h1.3l3.42,4.185V310.5Z",
    transform: "translate(-7.772 -16.071)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9664",
    "data-name": "Path 9664",
    d: "M391.09,313.952a3.8,3.8,0,0,1,6.574-2.348l-1.021.949a2.21,2.21,0,1,0,0,2.787l1.021.939a3.787,3.787,0,0,1-6.574-2.327Z",
    transform: "translate(-7.619 -16.073)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9665",
    "data-name": "Path 9665",
    d: "M404.9,310.5v6.89h-1.592v-2.817h-3.134v2.817H398.58V310.5h1.592v2.715h3.134V310.5Z",
    transform: "translate(-7.464 -16.071)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9666",
    "data-name": "Path 9666",
    d: "M92.752,202.209c6.063,76.894,70.576,137.6,149.032,137.6V302.04A111.825,111.825,0,0,1,130.051,190.348s1.684-19.5,2.858-25.366L95.722,158h0C94.365,164.666,92.211,195.431,92.752,202.209Z",
    transform: "translate(-13.816 -19.237)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9667",
    "data-name": "Path 9667",
    d: "M139.859,264.917l-.643,2.235v.061l.878,1.082,1.49-1.215,1.021,1.225-5.328,4.369-1.888-2.307c-1.164-1.429-1.153-2.919,0-3.9a2.246,2.246,0,0,1,2.583-.286l.735-2.593Zm-3.379,4.7.827,1.021,1.858-1.521-.827-1.021c-.612-.755-1.276-.847-1.858-.378s-.612,1.143,0,1.9Z",
    transform: "translate(-12.947 -17.045)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9668",
    "data-name": "Path 9668",
    d: "M134.09,259.316l1.021-.766,3.164,4.287-5.533,4.083-3.062-4.185,1.021-.766,2.144,2.919,1.2-.888-1.9-2.572,1.021-.735,1.9,2.572,1.276-.949Z",
    transform: "translate(-13.047 -17.149)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9669",
    "data-name": "Path 9669",
    d: "M125.14,256.028l7.38-1.358.878,1.307-4.083,6.3-.96-1.429,2.919-4.481-5.267.97Z",
    transform: "translate(-13.142 -17.23)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9670",
    "data-name": "Path 9670",
    d: "M124.8,255.512l-.847-1.358,5.849-3.644.847,1.347Z",
    transform: "translate(-13.166 -17.316)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9671",
    "data-name": "Path 9671",
    d: "M125.248,245.313l1.113-.643,2.674,4.614-5.982,3.46-2.613-4.5,1.113-.643,1.817,3.134,1.3-.755-1.613-2.766,1.082-.623,1.6,2.766,1.378-.8Z",
    transform: "translate(-13.239 -17.438)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9672",
    "data-name": "Path 9672",
    d: "M115,237.773l7.145-1.113.786,1.521-3.471,3.471,4.869-.725.766,1.511-5.1,5.1-.745-1.47,3.6-3.583-5.053.745-.664-1.307,3.624-3.624-5.1.786Z",
    transform: "translate(-13.352 -17.604)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9673",
    "data-name": "Path 9673",
    d: "M156.32,156.094,82.08,135.73,106.1,193.679Z",
    transform: "translate(-14.036 -19.7)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9674",
    "data-name": "Path 9674",
    d: "M137,156.529a111.9,111.9,0,0,1,104.863-73.3V45.46c-64.625,0-119.8,41.218-140.61,98.749Z",
    transform: "translate(-13.638 -21.574)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9675",
    "data-name": "Path 9675",
    d: "M141.37,103.892l2.583-1.766c1.868-1.276,3.91-1.021,5.1.7s.663,3.716-1.194,4.981l-2.583,1.766Zm5.665,2.889a2.144,2.144,0,1,0-2.409-3.532l-1.2.827,2.409,3.522Z",
    transform: "translate(-12.805 -20.414)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9676",
    "data-name": "Path 9676",
    d: "M155.513,101.033l.725,1.021-4.41,3L148,99.41l4.3-2.94.725,1.021-2.991,2.042.837,1.235,2.593-1.715.694,1.021-2.634,1.807.9,1.317Z",
    transform: "translate(-12.667 -20.515)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9677",
    "data-name": "Path 9677",
    d: "M159.629,94.442c.868,1.276.459,2.715-1.021,3.746l-1.143.786,1.021,1.572-1.307.9-3.889-5.7,2.46-1.684C157.271,92.993,158.761,93.166,159.629,94.442Zm-1.327.919c-.429-.633-1.082-.715-1.888-.174l-1.021.735,1.347,1.98,1.021-.735C158.567,96.616,158.72,95.973,158.3,95.361Z",
    transform: "translate(-12.557 -20.579)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9678",
    "data-name": "Path 9678",
    d: "M159,91.8l1.317-.9,3.154,4.614,2.848-1.95.735,1.021-4.175,2.848Z",
    transform: "translate(-12.439 -20.631)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9679",
    "data-name": "Path 9679",
    d: "M165.316,91.714a3.777,3.777,0,1,1,5.1.817,3.573,3.573,0,0,1-5.1-.817Zm4.9-3.348a2.154,2.154,0,1,0-.541,3.062,2.1,2.1,0,0,0,.541-3.062Z",
    transform: "translate(-12.324 -20.74)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9680",
    "data-name": "Path 9680",
    d: "M175.493,86.015l1.368,2.042-1.317.9-1.378-2.042L169.46,84.76l1.4-.949,3.236,1.47-.2-3.573,1.3-.878Z",
    transform: "translate(-12.221 -20.84)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9681",
    "data-name": "Path 9681",
    d: "M260.88,111.408,211.7,57.6,274.457,22.06Z",
    transform: "translate(-11.344 -22.06)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9682",
    "data-name": "Path 9682",
    d: "M328.071,119.246A111.723,111.723,0,0,0,243.94,81.028V43.26A149.525,149.525,0,0,1,356.5,94.37Z",
    transform: "translate(-10.675 -21.62)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9683",
    "data-name": "Path 9683",
    d: "M284.761,68.041l-2.042-.786.459-1.215,5.614,2.144-.47,1.215-2.042-.786-2.042,5.216-1.48-.572Z",
    transform: "translate(-9.869 -21.147)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9684",
    "data-name": "Path 9684",
    d: "M292.451,75.565,292,76.77l-5-1.919,2.47-6.431,4.859,1.868-.459,1.194-3.379-1.3-.541,1.4,2.991,1.143-.439,1.153-2.991-1.143-.572,1.49Z",
    transform: "translate(-9.781 -21.097)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9685",
    "data-name": "Path 9685",
    d: "M292.8,76.335l.929-.929a4.084,4.084,0,0,0,1.868,1.48c.888.337,1.358.184,1.511-.214.459-1.2-3.6-1.807-2.685-4.2.419-1.092,1.654-1.664,3.481-1.021a4.686,4.686,0,0,1,2.042,1.429l-.888.96a3.951,3.951,0,0,0-1.592-1.194c-.878-.337-1.347-.133-1.5.265-.459,1.194,3.593,1.807,2.695,4.165-.418,1.021-1.654,1.654-3.5.949a4.828,4.828,0,0,1-2.358-1.694Z",
    transform: "translate(-9.66 -21.04)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9686",
    "data-name": "Path 9686",
    d: "M302.042,74.631,300,73.845l.459-1.215,5.6,2.144-.459,1.215-2.042-.786-2.042,5.216L300,79.857Z",
    transform: "translate(-9.511 -21.01)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9687",
    "data-name": "Path 9687",
    d: "M374.615,260.26l-34.2-16.036c6.962-14.852,13.352-36.268,13.352-52.825A110.619,110.619,0,0,0,341.8,141c-1.378-2.725-6.38-11.78-7.758-14.056l32.317-19.558c1.98,3.287,7.452,13.27,9.126,16.547A147.909,147.909,0,0,1,391.54,191.4C391.54,213.539,383.955,240.345,374.615,260.26Z",
    transform: "translate(-8.804 -20.288)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9688",
    "data-name": "Path 9688",
    d: "M321.01,144.7l64.318-42.321L325.951,82.16Z",
    transform: "translate(-9.074 -20.812)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9689",
    "data-name": "Path 9689",
    d: "M368.425,150.28l.847,3.011c.612,2.174-.276,4.083-2.276,4.593a3.477,3.477,0,0,1-4.349-2.715l-.847-3.062Zm-4.542,4.451a2.144,2.144,0,1,0,4.083-1.153l-.4-1.409-4.083,1.164Z",
    transform: "translate(-8.227 -19.398)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9690",
    "data-name": "Path 9690",
    d: "M366.289,164.651l-1.245.276-1.174-5.2,6.706-1.521,1.154,5.1-1.245.286-.8-3.532-1.46.337.7,3.062-1.215.276-.7-3.124-1.552.357Z",
    transform: "translate(-8.184 -19.233)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9691",
    "data-name": "Path 9691",
    d: "M373.154,171.2l-7.3-1.725-.276-1.541,6.257-4.083.3,1.694-4.471,2.919,5.216,1.235Z",
    transform: "translate(-8.149 -19.116)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9692",
    "data-name": "Path 9692",
    d: "M368.41,177.863l-1.276.174-.715-5.288,6.829-.919.694,5.1-1.266.163-.49-3.583-1.48.2.429,3.164-1.225.163-.429-3.164-1.582.214Z",
    transform: "translate(-8.132 -18.95)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9693",
    "data-name": "Path 9693",
    d: "M374.139,178.44l.153,1.592-5.563.521.316,3.44-1.286.122-.48-5.022Z",
    transform: "translate(-8.114 -18.813)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9694",
    "data-name": "Path 9694",
    d: "M371.189,184.09a3.777,3.777,0,1,1-3.368,3.94,3.552,3.552,0,0,1,3.369-3.94Zm.3,5.91a2.154,2.154,0,1,0-2.307-2.042A2.113,2.113,0,0,0,371.485,190Z",
    transform: "translate(-8.103 -18.696)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9695",
    "data-name": "Path 9695",
    d: "M372.549,198.691c-1.541,0-2.5-1.143-2.5-2.981v-1.388h-1.9V192.73h6.88v2.981C375.04,197.528,374.121,198.681,372.549,198.691Zm0-1.613c.755,0,1.194-.5,1.194-1.47v-1.3h-2.389v1.307c-.01.97.439,1.47,1.184,1.47Z",
    transform: "translate(-8.096 -18.516)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9696",
    "data-name": "Path 9696",
    d: "M246.392,337.771H125.87V300H246.392A110.978,110.978,0,0,0,335.2,256.11l30,22.947A148.491,148.491,0,0,1,246.392,337.771Z",
    transform: "translate(-13.127 -17.2)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9697",
    "data-name": "Path 9697",
    d: "M312.23,247.235l64.084,42.658L371.72,227.34Z",
    transform: "translate(-9.257 -17.797)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2099",
    "data-name": "Group 2099",
    transform: "translate(112.743 209.543)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9698",
    "data-name": "Path 9698",
    d: "M380.173,289.892,375.58,227.34l-59.49,19.895,17.353,11.586A110.886,110.886,0,0,1,246.33,300.6H125.87v37.768H246.392a148.45,148.45,0,0,0,118.654-58.551Z",
    transform: "translate(-125.87 -227.34)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9699",
    "data-name": "Path 9699",
    d: "M311.478,296.48c.919,1.225.572,2.685-.888,3.787l-1.113.837,1.143,1.511-1.276.96-4.144-5.522,2.378-1.8C309.079,295.173,310.549,295.245,311.478,296.48Zm-1.3,1.021c-.449-.6-1.113-.663-1.888-.082l-1.021.786,1.439,1.909,1.021-.776c.776-.643.908-1.286.449-1.888Z",
    transform: "translate(-9.403 -16.382)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9700",
    "data-name": "Path 9700",
    d: "M310.76,293.859l1.276-.96,3.358,4.461,2.756-2.042.786,1.021L314.9,299.4Z",
    transform: "translate(-9.287 -16.436)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9701",
    "data-name": "Path 9701",
    d: "M322.3,291.937l-2.552,1.929.4,1.541-1.307,1.021-1.694-7.35,1.256-.949,6.615,3.654-1.337,1.021Zm-1.133-.663-2.46-1.449.715,2.766Z",
    transform: "translate(-9.155 -16.535)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9702",
    "data-name": "Path 9702",
    d: "M326.4,282.13l4.144,5.5-1.021.8-5.267-1.276,2.521,3.338-1.256.949-4.144-5.5,1.021-.8,5.247,1.276-2.511-3.338Z",
    transform: "translate(-9.067 -16.66)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9703",
    "data-name": "Path 9703",
    d: "M116.04,276.26v84.417l54.315-42.209Z",
    transform: "translate(-13.331 -16.782)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3527",
    "data-name": "Rectangle 3527",
    width: 112.754,
    height: 37.768,
    transform: "translate(0 282.803)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9704",
    "data-name": "Path 9704",
    d: "M62.882,316.411c0,1.531-1.153,2.491-3,2.491H58.492v1.9H56.9v-6.89h2.981C61.728,313.91,62.882,314.87,62.882,316.411Zm-1.623,0c0-.755-.49-1.2-1.46-1.2H58.492v2.4H59.8C60.769,317.605,61.259,317.156,61.259,316.411Z",
    transform: "translate(-14.559 -16)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9705",
    "data-name": "Path 9705",
    d: "M63.861,313.91h1.592V319.5h3.46v1.3h-5.1Z",
    transform: "translate(-14.415 -16)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9706",
    "data-name": "Path 9706",
    d: "M74.3,319.33H71.1l-.6,1.47H68.85l3.062-6.89h1.582l3.062,6.89H74.913Zm-.5-1.245-1.092-2.644-1.1,2.644Z",
    transform: "translate(-14.311 -16)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9707",
    "data-name": "Path 9707",
    d: "M83.449,313.91v6.89H82.1l-3.44-4.185V320.8H77.13v-6.89h1.317l3.42,4.185V313.91Z",
    transform: "translate(-14.139 -16)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-6",
    transform: "translate(155.437 121.603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9708",
    "data-name": "Path 9708",
    d: "M231.148,449.357l-2.9,30.807-16.659-1.235,2.848-30.878Z",
    transform: "translate(-151.363 -112.757)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9709",
    "data-name": "Path 9709",
    d: "M220,478.392c-.133,0,.47-6.768,1.368-15.077s1.715-15.036,1.858-15.015-.47,6.758-1.358,15.066S220.092,478.4,220,478.392Z",
    transform: "translate(-151.189 -112.752)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9710",
    "data-name": "Path 9710",
    d: "M228.443,477.456l-16.649-1.286-.2,2.174,16.659,1.235Z",
    transform: "translate(-151.363 -112.173)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9711",
    "data-name": "Path 9711",
    d: "M212.48,468.715a2.389,2.389,0,0,1,.531-.643,11.794,11.794,0,0,1,1.643-1.439,11.475,11.475,0,0,1,2.858-1.541,8.932,8.932,0,0,1,3.961-.51,8.83,8.83,0,0,1,6.206,3.45,7.643,7.643,0,0,1,1.021,1.929,2.1,2.1,0,0,1,.184.776,16.941,16.941,0,0,0-1.511-2.48,8.85,8.85,0,0,0-5.971-3.175,10.208,10.208,0,0,0-6.564,1.848C213.317,467.939,212.551,468.786,212.48,468.715Z",
    transform: "translate(-151.345 -112.415)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2100",
    "data-name": "Group 2100",
    transform: "translate(61.952 344.081)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9712",
    "data-name": "Path 9712",
    d: "M213.6,456.66l-.316,3.4,16.7,1.164.245-2.552Z",
    transform: "translate(-213.28 -456.66)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9713",
    "data-name": "Path 9713",
    d: "M296.7,447.22l2,30.878-16.649,1.419-2.062-30.939Z",
    transform: "translate(-149.943 -112.775)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9714",
    "data-name": "Path 9714",
    d: "M290.222,477.615c-.143,0-.6-6.757-1.021-15.1s-.674-15.118-.541-15.128.612,6.747,1.021,15.1S290.365,477.615,290.222,477.615Z",
    transform: "translate(-149.764 -112.771)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9715",
    "data-name": "Path 9715",
    d: "M298.519,475.39l-16.649,1.358.143,2.184,16.649-1.419Z",
    transform: "translate(-149.904 -112.19)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9716",
    "data-name": "Path 9716",
    d: "M281.37,469.282a4.1,4.1,0,0,1,.378-.7,11.279,11.279,0,0,1,1.4-1.674,11.164,11.164,0,0,1,2.582-1.97,8.881,8.881,0,0,1,10.493,1.3,7.934,7.934,0,0,1,1.337,1.735,2.257,2.257,0,0,1,.306.735,17.719,17.719,0,0,0-1.888-2.215,8.941,8.941,0,0,0-6.4-2.184,10.207,10.207,0,0,0-6.186,2.858C282.064,468.384,281.441,469.333,281.37,469.282Z",
    transform: "translate(-149.914 -112.431)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2101",
    "data-name": "Group 2101",
    transform: "translate(130.629 343.959)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9717",
    "data-name": "Path 9717",
    d: "M280.56,457.193l.235,3.4,16.669-1.49-.163-2.562Z",
    transform: "translate(-280.56 -456.54)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9718",
    "data-name": "Path 9718",
    d: "M250.816,180.826l-22.926,3.42-1.082-19.619s-1.654-.071-3.062-8.442-4.175-22.559-4.175-22.559h0a31.48,31.48,0,0,1,30.939-1.235l1.439.745Z",
    transform: "translate(-151.198 -119.384)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9719",
    "data-name": "Path 9719",
    d: "M250.21,143.6c.143-.082,5.7-2.664,6.431,3.062s-5.4,5.359-5.43,5.185S250.21,143.6,250.21,143.6Z",
    transform: "translate(-150.561 -119.093)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9720",
    "data-name": "Path 9720",
    d: "M222.786,146.85c-.163,0-5.675-.561-4.563,5.1s6.829,3.379,6.808,3.205S222.786,146.85,222.786,146.85Z",
    transform: "translate(-151.229 -119.012)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9721",
    "data-name": "Path 9721",
    d: "M252.7,142.973c-.112,4.951.47,7.452.174,10.789-.48,5.288-2.46,9.605-6.788,12.913s-10.749,4.3-15.383,1.5c-3.215-1.939-5.655-4.318-6.655-7.86s-2.46-9.861-3.062-13.495c-1.123-6.564-2.583-12.688-2.583-12.688l18.823-6.523,12.055,4.481Z",
    transform: "translate(-151.222 -119.411)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9722",
    "data-name": "Path 9722",
    d: "M236.37,170.307a9.024,9.024,0,0,0,6.533-1.776c-.082-.143-1.439.531-3.226,1.021S236.37,170.153,236.37,170.307Z",
    transform: "translate(-150.849 -118.562)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9723",
    "data-name": "Path 9723",
    d: "M253.138,151.459c-.235-5.012-.776-10.708-.817-16.026,0-2.042.245-4.92-.255-6.86a16.088,16.088,0,0,0-2.2-5.563,8.615,8.615,0,0,0-6.6-3.43,8.84,8.84,0,0,0-6.88,3.062,6.666,6.666,0,0,0-7.064-1.47,6.4,6.4,0,0,0-3.991,5.89,4.7,4.7,0,0,0-5.369.306,4.338,4.338,0,0,0-1.153,5.1,4.338,4.338,0,0,0-2.8,2.848,4.083,4.083,0,0,0,.959,3.848c1.113,1.194,2.848,1.664,4.083,2.776a4.706,4.706,0,0,1,1.133,5.1",
    transform: "translate(-151.275 -119.578)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9724",
    "data-name": "Path 9724",
    d: "M223.19,137.771a1.4,1.4,0,0,0,.306.5,3.888,3.888,0,0,0,1.327,1.021,4.236,4.236,0,0,0,2.644.367,4.471,4.471,0,0,0,2.879-1.909h-.429a4,4,0,0,0,3.062,2.45,4.869,4.869,0,0,0,4.287-1.245,6.411,6.411,0,0,0,1.95-3.5l-.459.123a5.6,5.6,0,0,0,4.767,1.613,5.2,5.2,0,0,0,3.45-2.042,4.941,4.941,0,0,0,1.021-2.409,2.041,2.041,0,0,0,0-.929,4.129,4.129,0,0,1-.143.9,5.348,5.348,0,0,1-1.072,2.246,4.951,4.951,0,0,1-3.246,1.807,5.155,5.155,0,0,1-4.308-1.521l-.357-.378-.1.51a6.064,6.064,0,0,1-1.807,3.215,4.308,4.308,0,0,1-3.8,1.113,3.522,3.522,0,0,1-2.715-2.042l-.163-.47-.265.429a4.083,4.083,0,0,1-2.552,1.776,4.022,4.022,0,0,1-2.44-.245,5.572,5.572,0,0,1-1.837-1.378Z",
    transform: "translate(-151.123 -119.324)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9725",
    "data-name": "Path 9725",
    d: "M222.874,135.614a4.95,4.95,0,0,1,.49-2.215,3.552,3.552,0,0,1,1.817-1.654,3.808,3.808,0,0,1,3.062.061l.531.255-.143-.551a4.226,4.226,0,0,1-.071-1.684,4.6,4.6,0,0,1,1.95-3.062,4.777,4.777,0,0,1,2.981-.745,6.666,6.666,0,0,1,2.746.96,2.474,2.474,0,0,0-.592-.551,4.665,4.665,0,0,0-2.113-.786,5.1,5.1,0,0,0-3.3.715,4.992,4.992,0,0,0-2.215,3.4,4.5,4.5,0,0,0,.092,1.888l.378-.306a4.277,4.277,0,0,0-3.471,0,3.829,3.829,0,0,0-2.011,1.919A3.645,3.645,0,0,0,222.68,135C222.752,135.409,222.843,135.624,222.874,135.614Z",
    transform: "translate(-151.133 -119.453)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9726",
    "data-name": "Path 9726",
    d: "M235.012,133.717c.071,0-.071-.327-.112-.8a3.644,3.644,0,0,1,.327-1.786c.3-.653.663-1.337.878-1.7a.572.572,0,0,1,.6-.214.261.261,0,0,0-.174-.214.684.684,0,0,0-.714.174,4.353,4.353,0,0,0-.561.766,6.122,6.122,0,0,0-.531,1.021,3.062,3.062,0,0,0-.214,2.042C234.675,133.533,235.012,133.758,235.012,133.717Z",
    transform: "translate(-150.889 -119.383)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9727",
    "data-name": "Path 9727",
    d: "M245.227,124.769c.061,0-.061-.449-.531-1.021a3.061,3.061,0,0,0-1.021-.755,2.46,2.46,0,0,0-1.623.01,3.807,3.807,0,0,0-2.123,1.807c-.347.592-.49,1.021-.429,1.021a3.969,3.969,0,0,0,.755-.827,4.083,4.083,0,0,1,1.95-1.5,2.327,2.327,0,0,1,2.225.582C244.91,124.473,245.115,124.81,245.227,124.769Z",
    transform: "translate(-150.784 -119.51)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9728",
    "data-name": "Path 9728",
    d: "M246,149.167a9.411,9.411,0,0,0,1.449-3.991,8.973,8.973,0,0,0,.051-4.216c-.163,0-.174,1.878-.592,4.083S245.868,149.167,246,149.167Z",
    transform: "translate(-150.649 -119.134)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9729",
    "data-name": "Path 9729",
    d: "M243.69,150.919a6.991,6.991,0,0,0,1.021-2.838,6.89,6.89,0,0,0,.245-2.991,10.729,10.729,0,0,0-.776,2.889A10.207,10.207,0,0,0,243.69,150.919Z",
    transform: "translate(-150.697 -119.048)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9730",
    "data-name": "Path 9730",
    d: "M227.76,153.77a8.891,8.891,0,0,0,1.48,4.93,9.289,9.289,0,0,0,3.634,3.736,31.91,31.91,0,0,1-3.154-4,30.844,30.844,0,0,1-1.96-4.665Z",
    transform: "translate(-151.028 -118.868)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9731",
    "data-name": "Path 9731",
    d: "M224.543,150.08a8.717,8.717,0,0,0,3.062,8.4,24.652,24.652,0,0,1-2.164-3.971A25.2,25.2,0,0,1,224.543,150.08Z",
    transform: "translate(-151.098 -118.945)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9732",
    "data-name": "Path 9732",
    d: "M226.74,179.433l.2-4.92,23.968-5.063.847,4.052Z",
    transform: "translate(-151.049 -118.542)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9733",
    "data-name": "Path 9733",
    d: "M153.243,237.787s-1.184.612-.367,1.48,11.729,10.544,13.209,11.494a31.061,31.061,0,0,0,5.88,2.093l2.879-.531,1.643-6.921,2.042-3.348-.521-.766,1.909-7.421s-1.654-.674-2.419.521c-1.072,1.684-2.552,4.42-2.552,4.42s-3,.449-4.083-.847-7.441-12.025-8.166-12.249-1.939,0-1.317,1.746,4.685,7.788,4.532,8.166-.776.786-1.021.49-6.778-8.85-7.809-9-1.878.735-.878,2.378,6.288,7.676,6.043,8.064-.939-.082-.939-.082-6.033-6.3-6.88-6.186-1.092,1.021-.612,1.848,6.584,6.7,6.7,7.145c.071.306-.184,1.521-.684,1.1S153.723,237.389,153.243,237.787Z",
    transform: "translate(-152.589 -117.376)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9734",
    "data-name": "Path 9734",
    d: "M213.683,299.322l-1.266,82.355-2.8,85.489,23.2,1.6,7.809-87.132,8.911-61.848,1.96-.122,17.547,64.38,10.932,82.682c1.358-.378,21.9-2.042,21.9-2.042L287.586,297.413,285.208,283.5l-61.083,1.358Z",
    transform: "translate(-151.404 -116.174)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9735",
    "data-name": "Path 9735",
    d: "M282.5,257.249l-1.766-47.629-2.94-32.889H257.768l-5.1-4.992-25.693,4.992-2.378,7.145s-20.63,6.564-21.773,8.564c0,0,7.237,28.581,10.647,44.567,2.338,10.983,4.8,22.243,4.8,22.243l-6.512,52.682c-.265,0,39.687-1.756,39.687-1.756L290.024,306Z",
    transform: "translate(-151.546 -118.495)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9736",
    "data-name": "Path 9736",
    d: "M301.682,162.516s-5.88.459-6.227.459-6.349.561-6.349.561a3.062,3.062,0,0,1,1.664-2.042c1.4-.623,4.083-1.592,4.328-2.042s.888-1.184.337-1.95-10.7-11.065-11.045-11.616-.909-1.6,0-1.807,2.042.766,2.787,1.388,4.706,3.961,5.1,3.756.071-.561.071-.561-6.706-6.9-6.778-7.145-.857-2.246,1.021-1.909c.919.153,7.88,7.278,8.166,6.992s-5.849-8.166-5.288-8.758,1.184-1.256,2.3,0,5.9,7.646,6.257,7.717a.582.582,0,0,0,.623-.766c-.133-.48-2.981-5.441-2.981-6s.551-.694,1.113-.766,6.533,8.574,6.533,8.574,4.614,7.421,5.1,8.278a28.583,28.583,0,0,1,1.327,3.756Z",
    transform: "translate(-149.862 -119.214)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9737",
    "data-name": "Path 9737",
    d: "M300.387,162.434l4,15.454-9.187,3.43-19.742-4.287v29.184l2.8,7.584s41.341-19.936,44.087-22.1c5.1-4.083-3.011-18.231-3.011-18.231l-7.5-16.148Z",
    transform: "translate(-150.037 -118.794)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9738",
    "data-name": "Path 9738",
    d: "M203.457,192.05l-4.624,9.258-11.678,38.667-13.045,3.481-2.45,11.923s20.415,4.787,24.192,3.144C202.273,255.735,213,229.114,213,229.114l-1.449-22.753Z",
    transform: "translate(-152.193 -118.073)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9739",
    "data-name": "Path 9739",
    d: "M316.767,183.8a37.333,37.333,0,0,0-6.125-4.206,36.626,36.626,0,0,0-6.992-2.419,6.706,6.706,0,0,1,2.195.2,19.517,19.517,0,0,1,5.032,1.745,19.8,19.8,0,0,1,4.389,3.062,6.41,6.41,0,0,1,1.5,1.613Z",
    transform: "translate(-149.452 -118.382)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9740",
    "data-name": "Path 9740",
    d: "M312.891,177.409a27.886,27.886,0,0,0-4.992-.388,28.583,28.583,0,0,0-4.889,1.021,10.555,10.555,0,0,1,9.881-.623Z",
    transform: "translate(-149.465 -118.396)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9741",
    "data-name": "Path 9741",
    d: "M257.326,176.63a6.446,6.446,0,0,1-1.123.776c-.367.245-.827.521-1.378.817s-1.174.643-1.888,1.021a47.18,47.18,0,0,1-5.1,2.113,64.062,64.062,0,0,1-6.482,1.776,68.944,68.944,0,0,1-12.178,1.562,36.873,36.873,0,0,1-3.716,0,7.427,7.427,0,0,1-1.368-.1,6.764,6.764,0,0,1,1.368-.112c.868,0,2.133-.092,3.7-.194a81.272,81.272,0,0,0,12.076-1.7c2.327-.521,4.512-1.143,6.472-1.776a37.583,37.583,0,0,0,5.1-2.042c.715-.306,1.347-.623,1.9-.9s1.021-.51,1.419-.735a6.759,6.759,0,0,1,1.2-.5Z",
    transform: "translate(-151.104 -118.393)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9742",
    "data-name": "Path 9742",
    d: "M263.353,257.6a7.149,7.149,0,0,1-1.47.378c-.959.214-2.348.459-4.083.694a67.085,67.085,0,0,1-27.112-2.042c-1.684-.49-3.062-.939-3.93-1.3a8.964,8.964,0,0,1-1.4-.592,7.052,7.052,0,0,1,1.46.4c.929.3,2.287.684,3.971,1.133a74.413,74.413,0,0,0,26.958,2.042c1.735-.184,3.134-.367,4.083-.521A9.444,9.444,0,0,1,263.353,257.6Z",
    transform: "translate(-151.078 -116.771)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9743",
    "data-name": "Path 9743",
    d: "M186.13,242.942c-.143,0,1.3-5.379,3.205-11.923s3.563-11.81,3.705-11.769-1.286,5.369-3.195,11.922S186.273,242.983,186.13,242.942Z",
    transform: "translate(-151.892 -117.508)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9744",
    "data-name": "Path 9744",
    d: "M247.5,272.66c.153,0,.418,5.941.6,13.27s.2,13.27.061,13.27-.418-5.931-.592-13.27S247.359,272.67,247.5,272.66Z",
    transform: "translate(-150.62 -116.399)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9745",
    "data-name": "Path 9745",
    d: "M262.314,316.9c0,.143-5.165,1.215-11.6,2.4s-11.657,2.042-11.688,1.868,5.165-1.215,11.6-2.4S262.283,316.757,262.314,316.9Z",
    transform: "translate(-150.794 -115.481)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9746",
    "data-name": "Path 9746",
    d: "M285.185,378.115a46.708,46.708,0,0,0-6.686.857,49.1,49.1,0,0,0-6.319,2.307,5.862,5.862,0,0,1,1.664-1.113,20.1,20.1,0,0,1,9.34-2.276,5.677,5.677,0,0,1,2,.225Z",
    transform: "translate(-150.105 -114.214)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9747",
    "data-name": "Path 9747",
    d: "M230.343,382.014c0,.153-1.919-.235-4.267-.123s-4.2.643-4.236.49a11.228,11.228,0,0,1,8.5-.367Z",
    transform: "translate(-151.151 -114.142)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9748",
    "data-name": "Path 9748",
    d: "M218.18,258.565a2.379,2.379,0,0,1-.163-.521c-.1-.408-.235-.909-.378-1.521-.327-1.4-.776-3.3-1.307-5.6-1.082-4.808-2.542-11.32-4.155-18.517s-3.062-13.719-4.134-18.527c-.521-2.307-.949-4.216-1.256-5.614l-.327-1.531a1.92,1.92,0,0,1-.082-.541,2.04,2.04,0,0,1,.184.521c.112.4.255.9.419,1.5.357,1.317.847,3.226,1.419,5.584,1.164,4.716,2.674,11.228,4.287,18.486s3.062,13.8,4.012,18.558c.47,2.327.857,4.236,1.133,5.635.112.623.214,1.133.286,1.541a1.858,1.858,0,0,1,.061.551Z",
    transform: "translate(-151.472 -117.78)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9749",
    "data-name": "Path 9749",
    d: "M278.18,192.79a1.8,1.8,0,0,1,.051.3l.071.857c.072.745.163,1.858.245,3.3.2,2.858.429,7.013.684,12.137.51,10.208,1.113,24.417,1.694,40.065.092,2.521.184,5.012.276,7.36h0c2.042,13.77,3.93,25.958,5.257,34.706.633,4.348,1.153,7.86,1.511,10.32.163,1.184.286,2.113.378,2.787a5.33,5.33,0,0,0,.092.725.635.635,0,0,1,0,.245.8.8,0,0,1-.061-.235,5.644,5.644,0,0,0-.133-.725c-.112-.663-.276-1.592-.48-2.766-.4-2.46-.96-5.961-1.664-10.3-1.378-8.779-3.277-20.956-5.431-34.706h0c-.082-2.358-.173-4.838-.276-7.36C279.191,218.523,278.292,195.689,278.18,192.79Z",
    transform: "translate(-149.981 -118.058)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2102",
    "data-name": "Group 2102",
    transform: "translate(73.966 60.033)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9750",
    "data-name": "Path 9750",
    d: "M254.652,178.39c-9.656,3.9-19.19,6.3-29.6,6.308a8.391,8.391,0,0,0,5.4,2.378,21.648,21.648,0,0,0,6.063-.521,90.657,90.657,0,0,0,14.74-4.144C252.958,181.8,254.877,180.033,254.652,178.39Z",
    transform: "translate(-225.05 -178.39)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2103",
    "data-name": "Group 2103",
    transform: "translate(55.48 90.074)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9751",
    "data-name": "Path 9751",
    d: "M206.94,207.82c.163,3.716-.255,8.166.531,11.831a22.038,22.038,0,0,0,4.634,9.993C210.319,222.641,208.8,214.965,206.94,207.82Z",
    transform: "translate(-206.94 -207.82)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2104",
    "data-name": "Group 2104",
    transform: "translate(85.113 146.073)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9752",
    "data-name": "Path 9752",
    d: "M236.286,262.731l-.316-.051c3.124,3.552,8.309,3.92,13.045,3.95s9.861-.265,13.035-3.777a64.032,64.032,0,0,1-25.764-.122Z",
    transform: "translate(-235.97 -262.68)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-6",
    transform: "translate(67.852 370.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9753",
    "data-name": "Path 9753",
    d: "M67.4,415.991c1.235,3.838,5.778,6.5,9.534,5.1,2.133-.806,3.675-2.664,4.992-4.522a20.836,20.836,0,0,1,4.389-5.175,6.451,6.451,0,0,1,4.481-1.266L73.537,403.64C66.147,408.091,66.167,412.174,67.4,415.991Z",
    transform: "translate(-66.786 -362.806)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9754",
    "data-name": "Path 9754",
    d: "M67.4,415.991c1.235,3.838,5.778,6.5,9.534,5.1,2.133-.806,3.675-2.664,4.992-4.522a20.836,20.836,0,0,1,4.389-5.175,6.451,6.451,0,0,1,4.481-1.266L73.537,403.64C66.147,408.091,66.167,412.174,67.4,415.991Z",
    transform: "translate(-66.786 -362.806)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2105",
    "data-name": "Group 2105",
    transform: "translate(0 40.834)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9755",
    "data-name": "Path 9755",
    d: "M67.4,415.991c1.235,3.838,5.778,6.5,9.534,5.1,2.133-.806,3.675-2.664,4.992-4.522a20.836,20.836,0,0,1,4.389-5.175,6.451,6.451,0,0,1,4.481-1.266L73.537,403.64C66.147,408.091,66.167,412.174,67.4,415.991Z",
    transform: "translate(-66.786 -403.64)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9756",
    "data-name": "Path 9756",
    d: "M152.066,420.293a14.587,14.587,0,0,0-23.9,5.737l1.725,6.686a8.166,8.166,0,0,1,4.246-5.42c2.256-1.021,4.879-.418,7.145.418s4.593,1.97,7.064,2.123,5.237-1.021,5.971-3.368S153.73,421.9,152.066,420.293Z",
    transform: "translate(-65.511 -362.544)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2106",
    "data-name": "Group 2106",
    transform: "translate(62.659 53.673)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9757",
    "data-name": "Path 9757",
    d: "M152.066,420.293a14.587,14.587,0,0,0-23.9,5.737l1.725,6.686a8.166,8.166,0,0,1,4.246-5.42c2.256-1.021,4.879-.418,7.145.418s4.593,1.97,7.064,2.123,5.237-1.021,5.971-3.368S153.73,421.9,152.066,420.293Z",
    transform: "translate(-128.17 -416.218)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9758",
    "data-name": "Path 9758",
    d: "M110.819,442.635c-3.613-3.43-3.43-9.4-1.633-14.046s5.737-8.166,10.126-10.555a32.072,32.072,0,0,1,27.938-.909,13.27,13.27,0,0,0-10.718,6.3c-1.98,3.287-2.419,7.278-4.083,10.749a16.914,16.914,0,0,1-21.661,8.462",
    transform: "translate(-65.931 -362.583)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9759",
    "data-name": "Path 9759",
    d: "M109.172,423.079c-4-4.716-4.532-12.249-3.94-18.445s2.042-12.351,1.021-18.466c-.572-3.614-1.98-7.074-2.45-10.708s.194-7.737,3.062-10.085c3.236-2.695,8.329-2.042,11.7.48s5.318,6.5,6.737,10.463c3.134,8.707,4.287,18.374,1.715,27.244s-8.615,16.832-17.465,19.517",
    transform: "translate(-66.02 -363.636)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9760",
    "data-name": "Path 9760",
    d: "M107.18,460.68a2.726,2.726,0,0,1,0-.541v-1.562a49.993,49.993,0,0,1,.49-5.716,77.192,77.192,0,0,1,1.531-8.37,38.361,38.361,0,0,1,3.828-9.687,40.033,40.033,0,0,1,6.237-8.34,39.586,39.586,0,0,1,6.543-5.441c1.021-.694,1.96-1.215,2.8-1.7s1.592-.817,2.2-1.113l1.439-.6a2.77,2.77,0,0,1,.51-.184l-.49.245-1.409.664c-.592.306-1.327.694-2.164,1.153a25.249,25.249,0,0,0-2.756,1.735,40.76,40.76,0,0,0-12.627,13.75c-3.675,6.431-4.685,13.188-5.41,17.925-.337,2.4-.5,4.348-.592,5.7,0,.653-.071,1.164-.092,1.552a3.194,3.194,0,0,1-.041.541Z",
    transform: "translate(-65.947 -362.52)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9761",
    "data-name": "Path 9761",
    d: "M68,408.634c1.929-2.674,6.706-3.45,9.728-2.113s5.226,3.981,7.207,6.615,3.9,5.43,6.635,7.268,6.574,2.5,9.3.653a7.993,7.993,0,0,0,3.164-5.471,18.373,18.373,0,0,0-.439-6.451c-.653-3.062-1.715-6.339-4.2-8.309-2.766-2.2-6.615-2.307-10.136-2.184a37.92,37.92,0,0,0-11.974,1.837c-3.8,1.409-7.676,4.44-9.289,8.166",
    transform: "translate(-66.76 -362.91)",
    fill: "#4EB6EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9762",
    "data-name": "Path 9762",
    d: "M101.548,455.133v-.643q0-.674-.061-1.837c0-1.623-.112-3.92-.194-6.747s-.2-6.247-.408-10-.49-7.9-1.021-12.249a39.4,39.4,0,0,0-1.225-6.2,32.089,32.089,0,0,0-2.358-5.379,30.815,30.815,0,0,0-2.858-4.491,29.73,29.73,0,0,0-3.124-3.43,23.027,23.027,0,0,0-5.533-3.777c-.368-.163-.684-.327-.96-.439l-.725-.276-.449-.184-.143-.072h.153l.459.143.735.255c.286.1.612.265,1.021.419a22.29,22.29,0,0,1,5.635,3.716,29.079,29.079,0,0,1,3.185,3.43,30.481,30.481,0,0,1,2.909,4.522,31.576,31.576,0,0,1,2.266,5.471,39.118,39.118,0,0,1,1.245,6.247c.572,4.318.847,8.462,1.021,12.249s.276,7.145.337,10.014.082,5.165.092,6.757v2.317a1.1,1.1,0,0,1,0,.184Z",
    transform: "translate(-66.459 -362.894)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9763",
    "data-name": "Path 9763",
    d: "M103.8,458.931a20.615,20.615,0,0,1-.817-3.175,33.206,33.206,0,0,1-.337-8.921,59.2,59.2,0,0,1,2.817-12.954c1.521-4.757,3.583-9.84,5.339-15.311a69.413,69.413,0,0,0,2.123-8.1,70.22,70.22,0,0,0,1.021-7.727,111.889,111.889,0,0,0,.235-13.27c-.133-3.767-.327-6.809-.449-8.911-.061-1.021-.112-1.858-.143-2.429v-.633a2.6,2.6,0,0,0,.061.633c0,.572.122,1.378.2,2.419.163,2.1.4,5.1.561,8.911a108.868,108.868,0,0,1-.163,13.27,70.827,70.827,0,0,1-1.021,7.768,68.043,68.043,0,0,1-2.123,8.166c-1.766,5.481-3.838,10.565-5.369,15.311a60.124,60.124,0,0,0-2.868,12.872,34.156,34.156,0,0,0,.235,8.881c.174,1.021.347,1.837.49,2.368q.092.388.153.612A2.212,2.212,0,0,1,103.8,458.931Z",
    transform: "translate(-66.044 -363.353)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9764",
    "data-name": "Path 9764",
    d: "M122.453,460.686H87.726L86.93,454h35.523Z",
    transform: "translate(-66.367 -361.76)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9765",
    "data-name": "Path 9765",
    d: "M91.36,459.8,95.7,479.848h18.874l4.063-20.048Z",
    transform: "translate(-66.275 -361.639)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9766",
    "data-name": "Path 9766",
    d: "M122.424,460.554c0,.092-7.635.143-17.057.112s-17.047-.122-17.047-.214,7.635-.143,17.047-.112S122.424,460.463,122.424,460.554Z",
    transform: "translate(-66.338 -361.628)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9767",
    "data-name": "Path 9767",
    d: "M116.358,470.3a14.606,14.606,0,0,0-3.062-1.756,11.1,11.1,0,0,0-3.716-.745,13,13,0,0,0-4.573.847c-1.582.531-3.062,1.154-4.5,1.5a10.787,10.787,0,0,1-3.889.112,8.3,8.3,0,0,1-2.5-.786,6.476,6.476,0,0,1-.6-.388c-.133-.1-.194-.153-.184-.163s.3.173.847.429a8.452,8.452,0,0,0,2.47.674,10.81,10.81,0,0,0,3.787-.174c1.4-.357,2.868-1.021,4.471-1.521a12.768,12.768,0,0,1,4.685-.827,10.433,10.433,0,0,1,3.8.827,9.871,9.871,0,0,1,2.266,1.327,6.618,6.618,0,0,1,.541.459C116.307,470.225,116.369,470.287,116.358,470.3Z",
    transform: "translate(-66.234 -361.48)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9768",
    "data-name": "Path 9768",
    d: "M116.082,471.606a15.315,15.315,0,0,0-2.94-1.725,9.861,9.861,0,0,0-3.583-.735,12.788,12.788,0,0,0-4.42.8c-1.531.51-2.97,1.1-4.338,1.47a11.145,11.145,0,0,1-3.736.418,6.259,6.259,0,0,1-2.45-.653,4.932,4.932,0,0,1-.592-.368c-.122-.1-.184-.153-.174-.163s.286.163.817.408a6.674,6.674,0,0,0,2.409.541,11.344,11.344,0,0,0,3.644-.48c1.337-.378,2.766-1.021,4.308-1.49a12.648,12.648,0,0,1,4.542-.786,9.9,9.9,0,0,1,5.839,2.133c.235.194.4.347.51.459A1.139,1.139,0,0,1,116.082,471.606Z",
    transform: "translate(-66.224 -361.452)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9769",
    "data-name": "Path 9769",
    d: "M116.713,469a16.656,16.656,0,0,0-3.144-1.848,11.65,11.65,0,0,0-3.807-.919,12.524,12.524,0,0,0-4.726.827,41.711,41.711,0,0,1-4.655,1.521,11.793,11.793,0,0,1-4.022,0,9.046,9.046,0,0,1-2.583-.817,4.291,4.291,0,0,1-.623-.388c-.133-.1-.2-.153-.194-.163s.306.174.878.439a10.045,10.045,0,0,0,2.562.694,11.872,11.872,0,0,0,3.92-.072,46.769,46.769,0,0,0,4.614-1.531,12.363,12.363,0,0,1,4.838-.827,11.81,11.81,0,0,1,6.206,2.4c.255.2.439.367.561.48a1.02,1.02,0,0,1,.174.2Z",
    transform: "translate(-66.242 -361.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9770",
    "data-name": "Path 9770",
    d: "M122.71,460.573c0,.092-7.809.174-17.445.174s-17.455-.082-17.455-.174,7.819-.163,17.455-.163S122.71,460.481,122.71,460.573Z",
    transform: "translate(-66.349 -361.627)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-6",
    transform: "translate(46.39 488.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9771",
    "data-name": "Path 9771",
    d: "M462.712,479.3c0,.153-93.349.276-208.461.276S45.76,479.449,45.76,479.3s93.329-.3,208.481-.3S462.712,479.153,462.712,479.3Z",
    transform: "translate(-45.76 -479)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-6",
    transform: "translate(154.873 120.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9772",
    "data-name": "Path 9772",
    d: "M210.418,165.851l-11.228-2.511a26.928,26.928,0,1,1,4.961-8.248h0Z",
    transform: "translate(-152.036 -118.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9773",
    "data-name": "Path 9773",
    d: "M210.416,165.852l-6.125-10.82a.112.112,0,0,0-.143,0h0l.184.092a26.775,26.775,0,0,0,1.439-13.9,23,23,0,0,0-1.021-4.083c-.255-.694-.49-1.4-.766-2.1l-1.021-2.042A27.145,27.145,0,0,0,176.5,118.7a27.367,27.367,0,0,0-11.331,3.787,26.54,26.54,0,0,0-8.891,8.728,26.938,26.938,0,0,0-4.083,12.055,27.438,27.438,0,0,0,1.746,12.055,26.3,26.3,0,0,0,6.349,9.616,27.234,27.234,0,0,0,18.721,7.615,28.939,28.939,0,0,0,8.687-1.439,26.723,26.723,0,0,0,11.565-7.717h-.092l11.228,2.419-11.228-2.613a.122.122,0,0,0-.1,0,26.54,26.54,0,0,1-11.5,7.584,28.663,28.663,0,0,1-8.595,1.388,26.989,26.989,0,0,1-18.466-7.564,26.2,26.2,0,0,1-6.237-9.493,26.969,26.969,0,0,1-1.7-11.882,26.469,26.469,0,0,1,3.991-11.861,26.009,26.009,0,0,1,8.748-8.605,27.092,27.092,0,0,1,11.2-3.675,26.448,26.448,0,0,1,11.085,1.276,26.908,26.908,0,0,1,15.036,12.709c.327.694.653,1.378,1.021,2.042a15.621,15.621,0,0,1,.766,2.042,24.224,24.224,0,0,1,1.021,4.083,26.765,26.765,0,0,1-1.358,13.78.1.1,0,0,0,.061.133.092.092,0,0,0,.112,0h-.184Z",
    transform: "translate(-152.035 -118.583)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9774",
    "data-name": "Path 9774",
    d: "M164.02,145.8l3.848-3.848,7.431,6.6,14.587-14.036,3.573,3.848-18.711,17.608Z",
    transform: "translate(-151.787 -118.252)",
    fill: "#4EB6EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductiterationPana);
export default __webpack_public_path__ + "static/media/Product iteration-pana.f2214b5abdc4ea81e74122998b6af61e.svg";
export { ForwardRef as ReactComponent };